
import { Component, Prop } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';

interface ErpVoucherFormModel {
  enabled: boolean;
  terminalUsername: string;
  terminalPassword: string;
  mobileUsername: string;
  mobilePassword: string;
}

@Component({
  components: { VFormBuilder },
})
export default class ErpVoucherForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: ErpVoucherFormModel };
  };

  get items() {
    return [
      {
        name: 'enabled',
        type: InputType.Checkbox,
        default: false,
        label: 'venue.form.erpVoucherEnabled',
      },
      {
        name: 'terminalUsername',
        type: InputType.Text,
        label: 'venue.form.terminalUsername',
      },
      {
        name: 'terminalPassword',
        type: InputType.Password,
        label: 'venue.form.terminalPassword',
      },
      {
        name: 'mobileUsername',
        type: InputType.Text,
        label: 'venue.form.mobileUsername',
      },
      {
        name: 'mobilePassword',
        type: InputType.Password,
        label: 'venue.form.mobilePassword',
      },
    ];
  }

  public getData() {
    return {
      rastpark: this.$refs.form.getData(),
    };
  }
}
